<template v-show="this.visible">
    <div class="p-inputtext-sm p-fluid"
        style="margin:15px;background-color: white;font-family: Arial, Helvetica, sans-serif;">
        <img alt="Logo" :src="'/assets/layout/images/logo-pdf.jpg'" style="width: 100%;" />
        <center>
            <b>
                <h4>PERFORMANCE APPRAISAL</h4>
            </b>
        </center>
        <br>
        <table>
            <tbody>
                <tr>
                    <td style="width:25%;">{{ $t('emp_name') }}</td>
                    <td style="width:25%;">{{ this.dataPdf.Employees.Name }}</td>
                    <td style="width:25%;">{{ $t('company') }}</td>
                    <td style="width:25%;">{{ this.dataPdf.Company_Name }}</td>
                </tr>
                <tr>
                    <td>{{ $t('emp_number') }}</td>
                    <td>{{ this.dataPdf.Employees.NIK }}</td>
                    <td>{{ $t('unit') }}</td>
                    <td>{{ this.dataPdf.Employees.Unit_Code }}</td>
                    <!-- <td>{{ $t('division') }}</td>
                    <td>{{ this.dataPdf.Division_Name }}</td> -->
                </tr>
                <tr>
                    <td>{{ $t('workdate') }}</td>
                    <td>{{ this.$formatYearFirst(this.dataPdf.Employees.Work_Begin_Date) }}</td>
                    <td>{{ $t('position') }}</td>
                    <td>{{ this.dataPdf.Position_Name }}</td>
                    <!-- <td>{{ $t('department') }}</td>
                    <td>{{ this.dataPdf.Department_Name }}</td> -->
                </tr>
                <tr>
                    <td>{{ $t('grade') }}</td>
                    <td>{{ this.dataPdf.Employees.Grade_Code }}</td>
                    <td>{{ $t('org_unit') }}</td>
                    <td>{{ this.dataPdf.Employees.Structure }}</td>
                </tr>
                <tr>
                    <td>{{ $t('warning_letter_period') }}</td>
                    <td>{{ this.dataPdf.Employees.Current_Warning_Letter }}</td>
                    <td>{{ $t('appraisal_period') }}</td>
                    <td>{{ this.dataPdf.Period_Year }}</td>
                </tr>
            </tbody>
        </table>
        <table v-if="this.dataPdf.Fortable == 'MANAGERIAL'" style="margin-top: 10px;">
            <tbody>
                <tr>
                    <td colspan="6">SECTION II SELF-EVALUATION</td>
                </tr>
                <template
                    v-for="(sect, index) in [...new Set(this.dataPdf.Questions.filter(a => a.Col_Area.indexOf('Section') > -1))]"
                    v-bind:key="sect.Col_Area">
                    <tr>
                        <td colspan="6">
                            {{ index + 1 }}. {{ this.$store.getters.getLanguage == 'id' ?
                            sect.Question_Ind :
                            sect.Question_Eng }}
                        </td>
                    </tr>
                    <tr>
                        <td colspan="6" v-html="sect.Answer"></td>
                    </tr>
                </template>
            </tbody>
        </table>
        <table style="margin-top: 10px;">
            <tbody>
                <template v-for="(proc, index) in [...new Set(this.dataPdf.Procedures)]" v-bind:key="proc.Col_Area">
                    <tr style="background:#92cddc;">
                        <td style="font-weight: bold;width:3%"> {{ proc.Col_Area }}</td>
                        <td colspan="4" style="font-weight: bold;width:87%"> {{ this.$store.getters.getLanguage == 'id'
                            ?
                            proc.Question_Ind : proc.Question_Eng }}</td>
                        <td style="font-weight: bold;width:10%;text-align: center !important;">{{ $t('rating') }}</td>
                    </tr>
                    <template
                        v-for="quest1 in [...new Set(this.dataPdf.Questions.filter(a => a.Col_Area.indexOf(proc.Col_Area) > -1 && a.Col_Area != 'Comment'))]"
                        v-bind:key="quest1.Col_Area" v-if="this.dataPdf.Fortable != 'FIRSTLINE'">
                        <tr style="background:#CCCCCC;">
                            <td style="font-weight: bold;">
                                {{ quest1.Point != 0 ? quest1.Col_Area.substring(1, 2) : '' }}
                            </td>
                            <td colspan="4" style="font-weight: bold;">
                                {{ this.$store.getters.getLanguage == 'id' ? quest1.Question_Ind : quest1.Question_Eng
                                }}
                            </td>
                            <td style="font-weight: bold;text-align: right;">
                                <!-- {{ quest1.Point != 0 ? quest1.Point + '%' : '' }} -->
                            </td>
                        </tr>
                        <template
                            v-for="qtdet in [...new Set(this.dataPdf.Question_Details.filter(a => a.Question_Id == quest1.Id))]"
                            v-bind:key="qtdet.Question_Id" v-if="quest1.Point == 0">
                            <tr>
                                <td colspan="2"></td>
                                <td colspan="3"> {{ this.$store.getters.getLanguage == 'id' ? qtdet.Question_Ind :
                                    qtdet.Question_Eng }}</td>
                                <td style="text-align: right;" v-if="quest1.Answer != qtdet.Point"> {{ qtdet.Point }}
                                </td>
                                <td style="text-align: right;background-color:#d4edb6;" v-else> <b>{{ qtdet.Point }}</b>
                                </td>
                            </tr>
                        </template>
                    </template>
                    <tr v-if="this.dataPdf.Fortable == 'FIRSTLINE' && proc.Col_Area == 'A'">
                        <td colspan="2"></td>
                        <td><b>{{ $t('objective') }}</b></td>
                        <td><b>{{ $t('achieve') }}</b></td>
                        <td><b>{{ $t('evaluate') }}</b></td>
                        <td></td>
                    </tr>
                    <template
                        v-for="(quest1, indexQ) in [...new Set(this.dataPdf.Questions.filter(a => a.Col_Area.indexOf(proc.Col_Area) > -1 && a.Col_Area != 'Comment'))]"
                        v-bind:key="quest1.Col_Area" v-if="this.dataPdf.Fortable == 'FIRSTLINE'">
                        <tr style="background:#CCCCCC;" v-if="quest1.Col_Area.substring(2, 3) == ''">
                            <td style="font-weight: bold;">
                                {{ quest1.Point != 0 ? quest1.Col_Area.substring(1, 2) : ''
                                }}
                            </td>
                            <td colspan="4" style="font-weight: bold;">
                                {{ this.$store.getters.getLanguage == 'id' ? quest1.Question_Ind : quest1.Question_Eng
                                }}
                            </td>
                            <td style="font-weight: bold;text-align: right;">
                                <!-- {{ quest1.Point != 0 ? quest1.Point + '%' : '' }} -->
                            </td>
                        </tr>
                        <template v-else-if="quest1.Col_Area.substring(2, 3) != '' && proc.Col_Area == 'A'">
                            <tr v-if="indexQ == 1 || indexQ == 6 || indexQ == 11">
                                <td colspan="2"></td>
                                <template v-for="qfirst in [...new Set(this.dataPdf.Questions
            .filter(a => a.Col_Area.indexOf(proc.Col_Area + quest1.Col_Area.substring(1, 2)) > -1 &&
                a.Col_Area != proc.Col_Area + quest1.Col_Area.substring(1, 2)))]" v-bind:key="qfirst.Col_Area">
                                    <td v-if="qfirst.Question_Eng != 'Point'" v-html="qfirst.Answer"></td>
                                    <td v-else style="text-align: center;">
                                        {{ qfirst.Answer }}
                                    </td>
                                </template>
                            </tr>
                        </template>
                        <template
                            v-for="qtdet in [...new Set(this.dataPdf.Question_Details.filter(a => a.Question_Id == quest1.Id))]"
                            v-bind:key="qtdet.Question_Id" v-if="quest1.Point == 0">
                            <tr>
                                <td colspan="2"></td>
                                <td colspan="3"> {{ this.$store.getters.getLanguage == 'id' ? qtdet.Question_Ind :
                                    qtdet.Question_Eng }}</td>
                                <td style="text-align: right;" v-if="quest1.Answer != qtdet.Point"> {{ qtdet.Point }}
                                </td>
                                <td style="text-align: right;background-color: #d4edb6;" v-else> {{ qtdet.Point }}</td>
                            </tr>
                        </template>
                    </template>
                    <tr style="background-color:#edd596;">
                        <td colspan="5" style="text-align: right;"><b>Sub-Total Score {{
                                proc.Col_Area
                                }}</b> </td>
                        <td style="text-align:right;"><b>{{ proc.Sub_Score }} %</b>
                        </td>
                    </tr>
                </template>
                <tr style="background-color:#edd596;">
                    <td colspan="5" style="text-align: right;"><b>TOTAL SCORE</b></td>
                    <td style="text-align: right;"><b>{{ this.dataPdf.Score }} %</b></td>
                </tr>
                <tr style="background-color:#edd596;">
                    <td colspan="5" style="text-align: right;"><b>Grade</b></td>
                    <td style="text-align: right;"><b>{{ this.dataPdf.Rate }}</b></td>
                </tr>
            </tbody>
        </table>
        <table style="margin-top: 10px;"
            v-bind:class="this.dataPdf.Fortable == 'MANAGERIAL' ? 'html2pdf__page-break' : ''">
            <tbody>
                <template v-for="qtcom in [...new Set(this.dataPdf.Questions.filter(a => a.Col_Area == 'Comment'))]"
                    v-bind:key="qtcom.Col_Area" v-if="this.dataPdf">
                    <tr>
                        <td colspan="6" style="background:#92cddc;">
                            <b>{{ $t('comment_review') }}</b>
                        </td>
                    </tr>
                    <tr>
                        <td colspan="6" v-html="qtcom.Answer"></td>
                    </tr>
                </template>
            </tbody>
        </table>
        <table v-if="this.dataPdf.Fortable == 'MANAGERIAL'" id="managerialDesc" style="margin-top: 10px;">
            <tbody>
                <template
                    v-for="(summ, index) in [...new Set(this.dataPdf.Questions.filter(a => a.Col_Area.indexOf('Summary') > -1))]"
                    v-bind:key="summ.Col_Area">
                    <tr>
                        <td colspan="6" style="background:#92cddc;">
                            {{ this.$store.getters.getLanguage == 'id' ?
                            summ.Question_Ind :
                            summ.Question_Eng }}
                        </td>
                    </tr>
                    <tr>
                        <td colspan="6" v-html="summ.Answer"></td>
                    </tr>
                </template>
            </tbody>
        </table>
        <table
            v-if="(this.dataPdf.S_Promotion || this.dataPdf.H_Promotion || this.dataPdf.OH_Promotion) &&
            (this.dataPdf.NIK_Approval1 == this.$store.getters.getUsername || this.dataPdf.NIK_Approval2 == this.$store.getters.getUsername ||
                this.$store.getters.getAccount == this.$ACCOUNT.ADMIN_HO || this.$store.getters.getAccount == this.$ACCOUNT.ADMIN_UNIT || this.$store.getters.getAccount == this.$ACCOUNT.OU_HEAD)"
            style="margin-top: 10px;">
            <thead>
                <tr>
                    <th style="background: chartreuse;font-weight: bold;">{{ $t('promotion_request') }}</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>
                        <div class="col-12 paddingno" style="display:flex">
                            <div class="col-3 paddingno">{{ $t('lengthWork') }}</div>
                            <div class="col-5 paddingno">: {{ this.$store.getters.getLanguage == 'id' ?
                                this.dataPdf.LengthWork.replace('years', 'tahun').replace('month', 'bulan') :
                                this.dataPdf.LengthWork }}</div>
                            <div class="col-4 paddingno"></div>
                        </div>
                        <div class="col-12 paddingno" style="display:flex">
                            <div class="col-3 paddingno">{{ $t('lengthGrade') }}</div>
                            <div class="col-5 paddingno">: {{ this.$store.getters.getLanguage == 'id' ?
                                this.dataPdf.LengthGrade.replace('years', 'tahun').replace('month', 'bulan') :
                                this.dataPdf.LengthGrade }}</div>
                            <div class="col-4 paddingno"></div>
                        </div>
                        <div class="col-12 paddingno" style="display:flex">
                            <div class="col-3 paddingno">{{ $t('warning_letter_period') }}</div>
                            <div class="col-5 paddingno">: {{ this.dataPdf.SP }}</div>
                            <div class="col-4 paddingno"></div>
                        </div>
                        <div class="col-12 paddingno" style="display:flex">
                            <div class="col-3 paddingno">{{ $t('education') }}</div>
                            <div class="col-5 paddingno">: {{ this.dataPdf.Education }}</div>
                            <div class="col-4 paddingno"></div>
                        </div>
                        <br />
                        <div class="col-12 paddingno" style="display:flex" v-if="this.dataPdf.S_Promotion">
                            <div class="col-3 paddingno">{{ $t('approved_by') }}</div>
                            <div class="col-5 paddingno">: Superior</div>
                            <div class="col-4 paddingno"></div>
                        </div>
                        <div class="col-12 paddingno" style="display:flex" v-if="this.dataPdf.S_Promotion">
                            <div class="col-3 paddingno">{{ $t('approved_date') }}</div>
                            <div class="col-5 paddingno">: {{ this.$formatDate(this.dataPdf.S_Date) }}</div>
                            <div class="col-4 paddingno"></div>
                        </div>
                        <div class="col-12 paddingno" style="display:flex" v-if="this.dataPdf.S_Promotion">
                            <div class="col-3 paddingno">{{ $t('remark') }}</div>
                            <div class="col-5 paddingno">: {{ this.dataPdf.S_Remark }}</div>
                            <div class="col-4 paddingno"></div>
                        </div>
                        <br />
                        <div class="col-12 paddingno" style="display:flex" v-if="this.dataPdf.H_Remark">
                            <div class="col-3 paddingno" v-if="this.dataPdf.H_Promotion">{{ $t('approved_by') }}</div>
                            <div class="col-3 paddingno" v-else>{{ $t('rejected_by') }}</div>
                            <div class="col-5 paddingno">: Head Superior</div>
                            <div class="col-4 paddingno"></div>
                        </div>
                        <div class="col-12 paddingno" style="display:flex" v-if="this.dataPdf.H_Remark">
                            <div class="col-3 paddingno" v-if="this.dataPdf.H_Promotion">{{ $t('approved_date') }}</div>
                            <div class="col-3 paddingno" v-else>{{ $t('rejected_date') }}</div>
                            <div class="col-5 paddingno">: {{ this.$formatDate(this.dataPdf.H_Date) }}</div>
                            <div class="col-4 paddingno"></div>
                        </div>
                        <div class="col-12 paddingno" style="display:flex" v-if="this.dataPdf.H_Remark">
                            <div class="col-3 paddingno">{{ $t('remark') }}</div>
                            <div class="col-5 paddingno">: {{ this.dataPdf.H_Remark }}</div>
                            <div class="col-4 paddingno"></div>
                        </div>
                        <br />
                        <div class="col-12 paddingno" style="display:flex" v-if="this.dataPdf.OH_Remark">
                            <div class="col-3 paddingno" v-if="this.dataPdf.OH_Promotion">{{ $t('approved_by') }}</div>
                            <div class="col-3 paddingno" v-else>{{ $t('rejected_by') }}</div>
                            <div class="col-5 paddingno">: Committee</div>
                            <div class="col-4 paddingno"></div>
                        </div>
                        <div class="col-12 paddingno" style="display:flex" v-if="this.dataPdf.OH_Remark">
                            <div class="col-3 paddingno" v-if="this.dataPdf.OH_Promotion">{{ $t('approved_date') }}
                            </div>
                            <div class="col-3 paddingno" v-else>{{ $t('rejected_date') }}</div>
                            <div class="col-5 paddingno">: {{ this.$formatDate(this.dataPdf.OH_Date) }}</div>
                            <div class="col-4 paddingno"></div>
                        </div>
                        <div class="col-12 paddingno" style="display:flex" v-if="this.dataPdf.OH_Remark">
                            <div class="col-3 paddingno">{{ $t('remark') }}</div>
                            <div class="col-5 paddingno">: {{ this.dataPdf.OH_Remark }}</div>
                            <div class="col-4 paddingno"></div>
                        </div>
                        <br />
                    </td>
                </tr>
            </tbody>
        </table>
        <table style="width:50%;margin-top: 30px;">
            <tbody>
                <tr>
                    <td>{{ $t('signature_reviewee') }}</td>
                    <td>{{ $t('signature_reviewer') }}</td>
                </tr>
                <tr style="height: 100px;">
                    <td></td>
                    <td></td>
                </tr>
                <tr>
                    <td>{{ $t('name_and_date') }} :</td>
                    <td>{{ $t('name_and_date') }} :</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
export default {
    name: "Editor",
    props: {
        isVisible: {
            type: Boolean,
            default: true,
        },
        dataPdf: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            indexName: "AppraisalIndex",
            url: this.$API_URL + "appraisal/",
            urlQuestion: this.$API_URL + "appraisal/getquestion/",
            mode: "",
            submitted: false,
            id: 0,
            formEditable: true,
            visible: false,
            NIK_Approval1: "",
            NIK_Approval2: "",
            points: [
                { name: "10", code: "10" },
                { name: "20", code: "20" },
                { name: "30", code: "30" },
                { name: "40", code: "40" },
                { name: "50", code: "50" }
            ]
        }
    },
    watch: {
        isVisible(newVal) {
            this.visible = newVal;
        }
    },
    methods: {
        getData() {
            this.NIK_Approval1 = this.dataPdf.NIK_Approval1;
            this.NIK_Approval2 = this.dataPdf.NIK_Approval2;

            var self = this;
            if (this.dataPdf.mode == this.$FORM_MODE_CREATE) {
                this.$axios.get(this.urlQuestion + this.dataPdf.Employee_Id + "/" + this.dataPdf.mode)
                    .then((response) => {
                        if (response.data.success) {
                            this.dataPdf.NIK_Approval1 = this.NIK_Approval1;
                            this.dataPdf.NIK_Approval2 = this.NIK_Approval2;
                            this.dataPdf.mode = response.data.data.header.mode;
                            this.dataPdf.Period_Year = response.data.data.header.Period_Year;
                            this.dataPdf.Employee_Id = response.data.data.header.Employee_Id;
                            this.dataPdf.Fortable = response.data.data.header.Fortable;

                            this.dataPdf.Details = response.data.data.header.Details;
                            this.dataPdf.Employees = response.data.data.header.Employees;
                            this.dataPdf.Procedures = response.data.data.header.Procedures;
                            this.dataPdf.Questions = response.data.data.header.Questions;
                            this.dataPdf.Question_Details = response.data.data.header.Question_Details;
                        }
                    })
                    .catch(function (error) {
                        alert(error);
                    });
            }

            this.dataPdf.Score = 0;
            this.dataPdf.Rate = "";

            this.dataPdf.Procedures.forEach((e, index) => {
                const subScore = this.subScore(e);
                const subRating = ((subScore * e.Point) / 100).toFixed(0);

                e.Sub_Score = subScore;
                e.Sub_Rating = subRating;
                this.dataPdf.Score += parseFloat(subRating);
                this.getTotalRating();
            });
        },
        showError(summary, message) {
            this.$emit('unblock-ui');
            this.$toast.add({ severity: 'error', summary: summary, detail: message, life: 3000 });
        },
        backToIndex() {
            this.showAppraisal = false;
        },
        toggle(event) {
            this.$refs.op.toggle(event);
        },
        hideRow(data) {
            return data.mode == this.$FORM_MODE_DELETE ? 'row-hidden' : null;
        },
        editDetail(sect, proc, e, from) {
            if (sect) {
                if (this.dataPdf.mode == this.$FORM_MODE_CREATE) {
                    sect.mode = this.$FORM_MODE_CREATE;
                }
                else {
                    sect.mode = this.$FORM_MODE_EDIT;
                }

                if (this.dataPdf.Fortable == "FIRSTLINE") {
                    if (from == "input") {
                        sect.Answer = e.target.innerHTML;
                    }
                    else if (from == "change") {
                        sect.Answer = e.htmlValue;
                    }
                    else {
                        this.dataPdf.Questions.filter(a => a.Col_Area == sect.Col_Area.substring(0, 2) && a.Point != 0)[0].Answer = sect.Answer;
                    }
                }
                else {
                    this.dataPdf.Questions.filter(a => a.Col_Area == sect.Col_Area && a.Point != 0)[0].Answer = sect.Answer;
                }
            }

            if (proc != undefined) {
                const subScore = this.subScore(proc);

                this.dataPdf.Procedures.filter(a => a == proc)[0].Sub_Score = subScore.toString();
                this.dataPdf.Procedures.filter(a => a == proc)[0].Sub_Rating = ((subScore * proc.Point) / 100).toFixed(0).toString();

                const dataArray = this.dataPdf.Procedures.map(a => parseFloat(a.Sub_Rating));
                const reducer = (accumulator, curr) => accumulator + curr;
                this.dataPdf.Score = dataArray.reduce(reducer).toFixed(0);
                this.getTotalRating();
            }
        },
        subScore(proc) {
            if (proc) {
                const dataArray = this.dataPdf.Questions
                    .filter(a => a.Col_Area.indexOf(proc.Col_Area) > -1 && a.Point != 0)
                    .map(a => ((((a.Point / 100) / (proc.Point / 100) * a.Answer)) * 100) / 50)

                if (dataArray.length <= 0) return 0;

                const reducer = (accumulator, curr) => accumulator + curr;
                return dataArray.reduce(reducer).toFixed(0);
            }
            else {
                return 0;
            }
        },
        getTotalRating() {
            var listCriteria = this.$store.getters.getCriteria.filter(a => a.Period_Year == this.dataPdf.Period_Year);
            listCriteria.some((e, index) => {
                if (this.dataPdf.Score > e.Range) {
                    this.dataPdf.Rate = e.Grade;
                    return true;
                }
            });
        },

    },
    created() {
        this.getData();
    },
    mounted() {
        this.visible = this.isVisible
    },
    computed: {
        years() {
            let years = [];

            for (var i = new Date().getFullYear(); i <= new Date().getFullYear() + 20; i++) {
                years.push({ value: i.toString() })
            }
            return years;
        },
        canEdit() {
            return this.dataPdf.mode == this.$FORM_MODE_CREATE || this.dataPdf.mode == this.$FORM_MODE_EDIT;
        },
    }
}
</script>
<style scoped>
.p-card-content {
    padding: 0px !important;
}

.firstline {
    width: 270px !important;
}

.managerial {
    width: 600px !important;
}

table {
    width: 100%;
}

table,
th,
td {
    border: 1px solid black;
    border-collapse: collapse;
    text-align: left;
    font-family: Arial, Helvetica, sans-serif;
    font-size: 9pt;
}

.paddingno {
    padding-bottom: 0px;
    padding-top: 0px;
    padding-left: 5px;
}
</style>